import { render } from "./EnvironmentManagement.vue?vue&type=template&id=623abd9f&scoped=true"
import script from "./EnvironmentManagement.vue?vue&type=script&lang=js"
export * from "./EnvironmentManagement.vue?vue&type=script&lang=js"

import "./EnvironmentManagement.vue?vue&type=style&index=0&id=623abd9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-623abd9f"]])

export default __exports__